<template>
    <fragment>
        <v-menu v-model="isOpen" offset-y bottom>
            <template #activator="bindings">
                <slot v-bind="bindings">
                    <v-btn x-small depressed class="ml-2" v-on="bindings.on">
                        manage<v-icon right x-small>menu_open</v-icon>
                    </v-btn>
                </slot>
            </template>
            <v-list>
                <v-list-item @click="isEditingSpendLimit = true">
                    <v-list-item-icon>
                        <v-icon>savings</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('subscriptionManageMenu.editSpendLimit') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item @click="isEditingName = true">
                    <v-list-item-icon>
                        <v-icon>edit</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('subscriptionManageMenu.editName') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
        <edit-subscription-name-dialog v-model="isEditingName" :subscription="value" @http2xx="$emit('input', $event)">
        </edit-subscription-name-dialog>
        <edit-subscription-spend-limit-dialog
            v-model="isEditingSpendLimit"
            :subscription="value"
            @http2xx="$emit('input', $event)"
        >
        </edit-subscription-spend-limit-dialog>
    </fragment>
</template>

<i18n>
{
    "en": {
        "subscriptionManageMenu.editSpendLimit": "Set Spend Limit",
        "subscriptionManageMenu.editName": "Edit Name"
    }
}
</i18n>

<script>
import EditSubscriptionNameDialog from '@/components/Domain.Subscriptions/EditSubscriptionNameDialog.vue';
import EditSubscriptionSpendLimitDialog from '@/components/Domain.Subscriptions/EditSubscriptionSpendLimitDialog.vue';
export default {
    components: { EditSubscriptionSpendLimitDialog, EditSubscriptionNameDialog },
    props: {
        value: Object,
    },
    data() {
        return {
            isOpen: false,
            isEditingName: false,
            isEditingSpendLimit: false,
        };
    }
};
</script>